<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M9.82,11.66C9.82,11.66,12.3,8.79,12.3,8.79C12.42,8.59,12.43,8.42,12.34,8.26C12.23,8.07,12.04,8,11.82,8C11.82,8,10.53,8,10.53,8C10.26,8,10.04,8.13,9.9,8.34C9.9,8.34,8.44,9.9,8.44,9.9C8.44,9.9,6.95,8,6.95,8C6.94,7.98,6.91,7.94,6.87,7.9C6.87,7.9,5.82,6.55,5.82,6.55C6.39,6.31,6.86,5.98,7.24,5.54C7.73,4.97,7.98,4.27,7.98,3.46C7.98,2.95,7.88,2.47,7.66,2.04C7.45,1.61,7.15,1.24,6.77,0.93C6.39,0.63,5.94,0.4,5.42,0.24C4.91,0.08,4.34,0,3.72,0C3.72,0,0.61,0,0.61,0C0.26,0,0,0.23,0,0.56C0,0.56,0,10.45,0,10.45C0,10.78,0.26,11,0.61,11C0.61,11,1.41,11,1.41,11C1.77,11,2.02,10.77,2.02,10.44C2.02,10.44,2.02,6.99,2.02,6.99C2.02,6.99,3.3,6.99,3.3,6.99C3.3,6.99,7.03,11.73,7.03,11.73C7.03,11.73,4.32,15.21,4.32,15.21C4.2,15.41,4.19,15.58,4.28,15.74C4.39,15.93,4.58,16,4.8,16C4.8,16,6.07,16,6.07,16C6.34,16,6.58,15.88,6.71,15.66C6.71,15.66,8.4,13.51,8.4,13.51C8.4,13.51,10.06,15.65,10.06,15.65C10.18,15.86,10.4,16,10.68,16C10.68,16,12.11,16,12.11,16C12.31,16,12.5,15.92,12.61,15.75C12.73,15.57,12.7,15.37,12.59,15.2C12.59,15.2,9.82,11.66,9.82,11.66C9.82,11.66,9.82,11.66,9.82,11.66ZM4.18,5C4.18,5,1.99,5,1.99,5C1.99,5,1.99,2.02,1.99,2.02C1.99,2.02,4.18,2.02,4.18,2.02C4.8,2.02,5.26,2.15,5.56,2.39C5.85,2.61,6,3.01,6,3.47C6,3.92,5.85,4.41,5.56,4.64C5.25,4.87,4.8,5,4.18,5C4.18,5,4.18,5,4.18,5ZM15,2C15,2,14,2,14,2C14,2,14,1,14,1C14,0.45,13.55,0,13,0C12.45,0,12,0.45,12,1C12,1,12,2,12,2C12,2,11,2,11,2C10.45,2,10,2.45,10,3C10,3.55,10.45,4,11,4C11,4,12,4,12,4C12,4,12,5,12,5C12,5.55,12.45,6,13,6C13.55,6,14,5.55,14,5C14,5,14,4,14,4C14,4,15,4,15,4C15.55,4,16,3.55,16,3C16,2.45,15.55,2,15,2C15,2,15,2,15,2ZM9.99,3.01C9.99,3.03,10,3.05,10,3.07C10,3.07,10,3,10,3C10,3,10,2.95,10,2.95C10,2.97,9.99,2.99,9.99,3.01C9.99,3.01,9.99,3.01,9.99,3.01Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'NewPrescription',
} as DefineComponent
</script>
